import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PawPrint, Play, Fish } from "lucide-react";
import Reveal from "../Reveal";
import VideoModal from "./VideoModal";

const Hero = () => {
  const [video, setVideo] = useState(false);

  return (
    <section className="relative overflow-hidden rounded-b-[40px] bg-pawelle-bg pt-32 md:pt-36">
      {/* decorative paws & fishbones */}
      <PawPrint className="pointer-events-none absolute left-6 top-24 h-24 w-24 -rotate-12 text-white opacity-70" />
      <PawPrint className="pointer-events-none absolute left-40 top-8 h-14 w-14 rotate-12 text-white opacity-60" />
      <PawPrint className="pointer-events-none absolute bottom-24 left-16 h-20 w-20 text-white opacity-70" />
      <PawPrint className="pointer-events-none absolute bottom-10 left-44 h-12 w-12 -rotate-12 text-white opacity-60" />
      <Fish className="pointer-events-none absolute left-2 top-1/2 h-16 w-16 text-white opacity-60" />
      <PawPrint className="pointer-events-none absolute right-4 bottom-24 h-16 w-16 rotate-12 text-white opacity-60" />
      <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-[#e9ddf5] opacity-60 blur-2xl" />

      <div className="relative mx-auto grid max-w-[1290px] items-center gap-8 px-5 pb-16 lg:grid-cols-2 lg:pb-0">
        {/* Left */}
        <div className="relative z-10 pb-8 lg:pb-24">
          <Reveal animation="rubberBand" delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full bg-pawelle-orange px-4 py-2 font-body text-[13px] font-bold uppercase tracking-wide text-white">
              <PawPrint className="h-4 w-4" />
              Welcome to Moggies &amp; Doggies
            </span>
          </Reveal>

          <Reveal animation="rubberBand" delay={200}>
            <h1 className="mt-5 font-display text-[40px] font-bold uppercase leading-[1.02] text-pawelle-ink sm:text-[52px] lg:text-[64px]">
              Expert Care. Genuine Love. Prices That Are Fair.
            </h1>
          </Reveal>

          <Reveal animation="rubberBand" delay={300}>
            <h4 className="mt-6 max-w-lg font-display text-[19px] font-medium leading-snug text-pawelle-ink md:text-[22px]">
              Affordable, age-inclusive veterinary care for every family. Pets aren't a luxury — they're family.
            </h4>
          </Reveal>

          <div className="mt-9 flex items-center gap-5">
            <Link
              to="/gb/en/appointment.html"
              className="rounded-full bg-pawelle-primary px-8 py-4 font-display text-[16px] font-medium text-white shadow-[0_12px_28px_rgba(114,82,155,0.35)] transition-all duration-300 hover:bg-pawelle-primary-dark hover:-translate-y-0.5"
            >
              Get Started
            </Link>
            <button
              onClick={() => setVideo(true)}
              className="pw-ripple relative flex h-16 w-16 items-center justify-center rounded-full bg-pawelle-primary text-white transition-transform hover:scale-105"
              aria-label="Play video"
            >
              <Play className="relative z-10 h-6 w-6 translate-x-0.5 fill-white" />
            </button>
          </div>
        </div>

        {/* Right image */}
        <Reveal animation="fadeInUp" delay={200} className="relative z-10 flex justify-center lg:justify-end">
          <img
            src="/pawelle/img_2.png"
            alt="Happy pet owner holding a puppy"
            className="w-full max-w-[560px] object-contain"
          />
        </Reveal>
      </div>

      <VideoModal open={video} onClose={() => setVideo(false)} />
    </section>
  );
};

export default Hero;
